module.exports = __webpack_public_path__ + "static/img/22.a0e3efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/22.png
// module id = zHDu
// module chunks = 0